<app-header-loja #menutopo [busca]="true" (evtVoltar)="apertouVoltar($event)" (mudouValorBusca)="testeBusca($event)"></app-header-loja>

<div class="container mt-3 mercado" style="position: relative">

  <div class="k-i-loading ml-1 mr-1 centralizado" *ngIf="carregando" style="font-size: 40px;height: 90px; position: absolute; top: 0px; left: 45%;" ></div>

  <div class="alert alert-info" *ngIf="!carregando && !categorias.length">
    Nenhum produto encontrado <span *ngIf="termoBusca"> com "<b>{{termoBusca}}</b>"</span>
  </div>

  <div class="alert alert-info" *ngIf="!carregando && msgBusca">
      {{msgBusca}}
  </div>

  <ng-container *ngIf="!nomeCategoria && listaItensPorCategoria">
    <div  *ngFor="let categoria of categorias">
      <h4 *ngIf="(produtosPorCategoria[categoria.nome])?.length > 0">{{categoria.nome}}</h4>
        <div class="row mb-2" *ngFor="let grupo of listaItensPorCategoria[categoria.nome] " >
          <ng-container *ngFor="let produto of grupo"   >
            <div  (click)="abraDetalhesProduto(produto)" class="col produto pt-2 pb-2"
                  style=" max-width: 165px; display:inline-block;">
              <div  style="width: 128px; height: 110px; margin-bottom: 4px  " class="justify-content-center align-items-center ">
                <img *ngIf="produto.imagens && produto.imagens.length > 0; else imagemEan" class="img img-fluid" [src]="'/images/empresa/' + produto.imagens[0].linkImagem" alt="Imagem" >
                <ng-template #imagemEan>
                  <img *ngIf="produto.imagemCodigoDeBarras" class="img img-fluid" [src]="'/images/produtos/' + (produto.imagemCodigoDeBarras.linkImagem ? produto.imagemCodigoDeBarras.linkImagem : 'carrinho-produtos.svg' )" alt="Imagem" >
                </ng-template>

                <!--<ng-container *ngIf="produto.imagens && produto.imagens.length > 0">

                </ng-container>-->

              </div>
              <div class="media">
                <div class="media-body pt-0 cinco-linhas">
                  <h5 class="mt-0 mb-1 font-15"><span class=" text-muted font-12"  *ngIf="produto.valorMinimo"><i>A partir de</i></span>

                    {{(produto.valorMinimo ? produto.valorMinimo : produto.preco) | currency: 'BRL'}}</h5>
                  <h5 class="preco font-14" *ngIf="!produto.indisponivel">

                    <i *ngIf="produto.qtdMaxima"><label class="text-muted" style="font-size: 10px">*Até {{produto.qtdMaxima}} por pedido</label></i>
                    <span *ngIf="exibirUnidade(produto)" class="text-muted font-11">
               / kg
            </span>
                  </h5>

                  <h5 *ngIf="produto.indisponivel" class="text-danger">Esgotado!</h5>

                  <span>{{produto.nome}}</span><br>
                  <span class="text-muted">{{produto.descricao}}</span>


                </div>

              </div>
            </div>
          </ng-container>


        </div>
    </div>
  </ng-container>
  <ng-container *ngIf="nomeCategoria && listaItensPorCategoria">
    <div class="container-viewport" *ngFor="let categoria of categorias">
      <h4 *ngIf="(listaItensPorCategoria[categoria.nome])?.length > 0">{{categoria.nome}}</h4>
      <cdk-virtual-scroll-viewport  itemSize="220" (scrolledIndexChange)="busqueMaisProdutos($event)">
        <div class="row" *cdkVirtualFor="let grupo of listaItensPorCategoria[categoria.nome]"  >
          <ng-container *ngFor="let produto of grupo" >
            <div (click)="abraDetalhesProduto(produto)" class="col produto pt-2 pb-2"
                  style=" width: 150px; display:inline-block;">
              <div class=" justify-content-center align-items-center" style="width: 128px; height: 92px; margin-bottom: 4px "  >
                <img *ngIf="produto.imagens && produto.imagens.length > 0" class="img img-fluid" [src]="'/images/empresa/' + produto.imagens[0].linkImagem" alt="Imagem" >
                <img *ngIf="produto.imagemCodigoDeBarras" class="img img-fluid" [src]="'/images/produtos/' + (produto.imagemCodigoDeBarras.linkImagem ? produto.imagemCodigoDeBarras.linkImagem : 'carrinho-produtos.svg' )" alt="Imagem" >

                <!--<ng-container *ngIf="produto.imagens && produto.imagens.length > 0">

                </ng-container>-->

              </div>
              <div class="media">
                <div class="media-body pt-0 cinco-linhas">

                  <h5 class="mt-0 mb-1 font-15"><span class=" text-muted font-12"  *ngIf="produto.valorMinimo"><i>A partir de</i></span>

                    {{(produto.valorMinimo ? produto.valorMinimo : produto.preco) | currency: 'BRL'}}</h5>
                  <h5 class="preco font-14" *ngIf="!produto.indisponivel">

                    <i *ngIf="produto.qtdMaxima"><label class="text-muted" style="font-size: 10px">*Até {{produto.qtdMaxima}} por pedido</label></i>
                    <span *ngIf="exibirUnidade(produto)" class="text-muted font-11">
               / kg
            </span>
                  </h5>


                  <h5 *ngIf="produto.indisponivel" class="text-danger">Esgotado!</h5>
                  <span>{{produto.nome}}</span><br>
                  <span class="text-muted">{{produto.descricao}}</span>



                </div>

              </div>
            </div>
          </ng-container>
          <br>

        </div>

      </cdk-virtual-scroll-viewport>
    </div>
  </ng-container>


</div>
<div class="mb-3">
</div>
